<template>
  <app-layout>
    <template #header>
      <div class="flex justify-between">
        <div>
          <h2 class="font-semibold text-xl text-gray-800 leading-tight">
            Controle de Acesso
          </h2>
        </div>
        <div class="float-right">
          <div
            @click="openNovoGrupo = true"
            class="cursor-pointer"
          >Novo Grupo</div>
        </div>
      </div>
    </template>
    <div class="max-w-7xl mx-auto py-2 sm:px-2 lg:px-2">
      <div class="flex  divide-x ">
        <div class="w-1/4 p-4  px-8">
          <div class="py-3 ">
            <div
              v-for="role in roles"
              :key="role.id"
              class="py-2 cursor-pointer text-right "
              @click="selectRole(role)"
            >
              <span :class="{'text-gray-400':  form.id !== role.id ,
              'text-gray-900 font-bold':form.id === role.id }">{{role.name}}</span>
            </div>
          </div>

        </div>
        <div class="w-3/4 p-4 px-8">

          <form @submit.prevent="save">

            <div
              v-for="(value, key) in permissions"
              :key="key"
              class="py-3"
            >
              <div class="py-2  ">
                {{key}}
              </div>
              <div class="bg-white  rounded  px-4 py-6 grid grid-flow-row grid-cols-3
                gap-4 ">
                <div
                  v-for="permission in permissions[key]"
                  :key="permission.id"
                  class="flex"
                >
                  <input
                    type="checkbox"
                    class="self-center cursor-pointer form-checkbox  mr-2 w-4 h-4 text-gray-600"
                    checked
                    :value="permission.id"
                    v-model="form.permissions"
                  >
                  <label class="font-medium text-sm text-gray-700">
                    <span> {{permission.name}}</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="flex flex-row-reverse space-x-4 space-x-reverse px-4 sm:py-6">

              <button-primary
                :class="{ 'opacity-25': form.processing }"
                :disabled="form.processing"
              > Salvar
              </button-primary>
              <button-secondary @click.native="selectRole(roleSelected)">
                Cancelar
              </button-secondary>
              <jet-action-message
                :on="form.recentlySuccessful"
                class="mt-2 mr-3"
              >
                Salvo.
              </jet-action-message>
            </div>

          </form>

        </div>
      </div>
    </div>
    <jet-modal
      :show="openNovoGrupo"
      :closeable="true"
      @close="openNovoGrupo = false"
      max-width="2xl"
    >
      <role-create
        v-if="openNovoGrupo"
        @close="openNovoGrupo = false"
      ></role-create>
    </jet-modal>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import AlertError from '@/Components/AlertError';
import CheckBox from '@/Components/CheckBox';
import ButtonPrimary from '@/Components/ButtonPrimary';
import ButtonSecondary from '@/Components/ButtonSecondary';
import JetModal from '@/Jetstream/Modal';
import RoleCreate from './RoleCreate';
import JetActionMessage from '@/Jetstream/ActionMessage'
export default {
  name: 'AccessControleList',
  props: ['roles', 'permissions'],
  components: {
    AppLayout,
    AlertError,
    RoleCreate,
    JetModal,
    JetActionMessage,
    CheckBox,
    ButtonPrimary,
    ButtonSecondary
  },
  data() {
    return {
      isLoading: false,
      openNovoGrupo: false,
      form: this.$inertia.form({
        '_method': 'PUT',
        id: null,
        permissions: []
      }, {
        resetOnSuccess: false,
      }),
      roleSelected: {}
    }
  },
  methods: {
    selectRole({ id, permissions }) {
      this.roleChange = false;
      this.roleSelected = { id, permissions }
      this.form.id = id;
      this.form.permissions = permissions;
      this.roleChange = true;
    },
    save() {
      this.form.post(
        route('accesscontrol.role.update', this.form.id),
        {
          preserveScroll: true
        },
        {
          resetOnSuccess: false,
        });
    }
  },
  created() {
    const [firstRole] = this.roles;
    this.selectRole(firstRole);
  }
}
</script>


<style scoped>
</style>
